import * as Yup from 'yup';

export const VALIDATION_SCHEMA = t =>
  Yup.object().shape({
    amount: Yup.number()
      .min(1, t('validation:val_amount_min_amount_is_1_eur'))
      .max(9999999, t('validation:val_amount_max_amount'))
      .required(t('validation:val_amount_required')),
    method: Yup.object().required(t('validation:val_method_required')),
  });
